export interface UploadFileQueue {
	[jobId: string]: any[];
}